/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Createdescription1Inputs */

const zh_course_createdescription1 = /** @type {(inputs: Course_Createdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建一个课程来组织你的学习资料`)
};

const en_course_createdescription1 = /** @type {(inputs: Course_Createdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a course to organize your study materials`)
};

const es_course_createdescription1 = /** @type {(inputs: Course_Createdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un curso para organizar tus materiales de estudio`)
};

/**
* | output |
* | --- |
* | "Create a course to organize your study materials" |
*
* @param {Course_Createdescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_createdescription1 = /** @type {((inputs?: Course_Createdescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Createdescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_createdescription1(inputs)
	if (locale === "en") return en_course_createdescription1(inputs)
	return es_course_createdescription1(inputs)
});
export { course_createdescription1 as "course_createDescription" }